module.exports = __webpack_public_path__ + "img/sofacama.6496f6ef.svg";